export const USER_ROLE_ID = "userRoleId";
export const SALE_STATUS = "estadoVenda";
export const INIT_MONTH = "mesInicial";
export const END_MONTH = "mesFinal";
export const ROLE = "role";
export const YEAR = "ano";

//export const DEFAULT_LIMIT_PER_PAGE = 25; //TODO: Generalizar mesmo para todas as tabelas?
